// extracted by mini-css-extract-plugin
export default {"mainContainer":"AppBar_mainContainer__z2mWU","pageTitle":"AppBar_pageTitle__GfNwo"};